export const environment = {
  graphqlUrl: `${location.origin}/graphql`,
  graphqlWsUrl: `wss://${location.host}/graphql`,
  apiUrl: `${location.origin}/api`,
  redirectUri: `${location.origin}/auth/callback`,
  postLogoutRedirectUri: `${location.origin}/signedout`,
  requireHttps: true, // required for running locally
  version: require('../../app.json').version,
};
